import { useEffect, useMemo } from "react";
// outsource
import { Row, Col, Spin } from "antd";
// redux
import { useDispatch, useSelector } from "react-redux";
import {
  snapGeneral,
  unSnapGeneral,
  saveGeneral,
} from "../../../store/payout_setting/payout_setting.action";
import {
  generalSelector,
  generalLoadingSelector,
} from "../../../store/payout_setting/payout_setting.selector";
// components
import PayoutSettingPayoutRateSection from "./component/payout_setting_payout_rate_section";
import PayoutSettingRoundingSection from "./component/payout_setting_rounding_section";

const EXAMPLES = [
  { key: 1, actual: "From 08:00 to 08:09", rounded: "08:00" },
  { key: 2, actual: "From 08:10 to 08:19", rounded: "08:15" },
  { key: 3, actual: "After 08:20 to 08:30", rounded: "08:30" },
];

const PayoutSettingGeneralTab = () => {
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const general = useSelector(generalSelector);
  const loading = useSelector(generalLoadingSelector);

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(snapGeneral());
    return () => dispatch(unSnapGeneral());
  }, [dispatch]);

  // -------------------------- FUNCTION --------------------------
  const payoutRate = useMemo(
    () => ({
      afterHourRate: general?.afterHourRate ?? 1,
      holidayRate: general?.holidayRate ?? 2,
    }),
    [general],
  );

  const rounding = useMemo(
    () => ({
      baseInterval: general?.roundingBaseInterval ?? 30,
      rules: (
        general?.roundingRules ?? [
          { from: 0, to: 9, roundTo: 0 },
          { from: 10, to: 19, roundTo: 15 },
          { from: 20, to: 30, roundTo: 30 },
        ]
      ).map((r, i) => ({ ...r, key: i + 1 })),
    }),
    [general],
  );

  const handleSaveRate = ({ afterHourRate, holidayRate }) => {
    dispatch(
      saveGeneral({
        afterHourRate,
        holidayRate,
        roundingBaseInterval: rounding.baseInterval,
        roundingRules: rounding.rules.map(({ from, to, roundTo }) => ({
          from,
          to,
          roundTo,
        })),
      }),
    );
  };

  const handleSaveRounding = ({ baseInterval, rules }) => {
    dispatch(
      saveGeneral({
        afterHourRate: payoutRate.afterHourRate,
        holidayRate: payoutRate.holidayRate,
        roundingBaseInterval: baseInterval,
        roundingRules: rules.map(({ from, to, roundTo }) => ({
          from,
          to,
          roundTo,
        })),
      }),
    );
  };

  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Spin spinning={loading}>
        <Row gutter={[0, 16]}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <PayoutSettingPayoutRateSection
              data={payoutRate}
              onSave={handleSaveRate}
            />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <PayoutSettingRoundingSection
              data={rounding}
              examples={EXAMPLES}
              onSave={handleSaveRounding}
            />
          </Col>
        </Row>
      </Spin>
    );
  };

  // -------------------------- MAIN --------------------------
  return renderBody();
};

export default PayoutSettingGeneralTab;
